(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  // ── Filtros: submit automático al cambiar checkbox ──
  const sidebar = document.getElementById('CollectionSidebar');
  if (!sidebar) return;

  // Recolectar todos los checkboxes de filtro
  const checkboxes = sidebar.querySelectorAll('.filter-checkbox');

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', function () {
      buildFilterURL();
    });
  });

  function buildFilterURL() {
    var url = new URL(window.location.href);

    // Limpiar params de filtro previos (filter.*)
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.startsWith('filter.')) {
        url.searchParams.delete(key);
      }
    });

    // Agregar filtros activos
    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        url.searchParams.append(cb.name, cb.value);
      }
    });

    // Volver a página 1 al filtrar
    url.searchParams.delete('page');

    window.location.href = url.toString();
  }

  // ── Sort select ──
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ── Toggle de grupos de filtro ──
  var toggles = sidebar.querySelectorAll('.filter-group__toggle');

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      var body = document.getElementById(this.getAttribute('aria-controls'));
      if (body) {
        body.hidden = expanded;
      }
    });
  });

})();


  } catch(e) { console.error(e); }
})();
})();
